<template>
  <div class="animated fadeIn">


    <!-- table -->
    <b-card v-show="so.adv" class="mt-2">
      <b-row>
        <b-col md="6">
          <b-form-group>
            <label>Registed_at</label>
            <b-form inline>
              <date-picker class="mt-2 mr-2" v-model="so.opt.created_at_sd" style="width: 140px" :confirm="true"
                :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
              ~
              <date-picker class="ml-2" v-model="so.opt.created_at_ed" style="width: 140px" :confirm="true"
                :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group class="float-right">
        <b-button class="mr-1" size="sm" variant="danger" @click="so.adv = false"> Close </b-button>
        <b-button class="mr-1" size="sm" variant="light" @click="resetField"> Reset </b-button>
        <b-button size="sm" variant="primary" @click="refresh"> Search </b-button>
      </b-form-group>
    </b-card>

    <b-row class="mt-3">
      <b-col md="4">
        <b-form-fieldset style="width : 120px" size="sm">
          <b-form-select :options="so.pageoptions" v-model="so.perPage">
          </b-form-select>
        </b-form-fieldset>
      </b-col>
      <b-col md="4">
        <p class="d-inline">Task : {{ task || '0' }}</p>
        <div class="pull-right">
          <b-button class="" size="sm" variant="primary" @click="() => modal_add = true"> Create </b-button>
        </div>
      </b-col>
      <b-col>
        <b-input-group style="" size="sm" class="float-right">
          <b-input-group-prepend>
            <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
            <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
            <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
              <b-dropdown-item size="sm" @click="so.sk = 'name'; so.skt = 'Name'">Name</b-dropdown-item>
              <b-dropdown-item size="sm" @click="so.sk = 'code'; so.skt = 'Code'">Code</b-dropdown-item>
            </b-dropdown>
          </b-input-group-prepend>
          <b-input v-model="so.sv" @keyup.enter="refresh()"></b-input>
          <b-input-group-append>
            <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
            <b-btn variant="outline-secondary" @click="so.adv = !so.adv"><i class="fa"
                :class="{ 'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>

    <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
      :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" class="">
      <template #cell(id)="row">{{ row.item.id }}</template>
      <template #cell(is_alive)="row">
        <b-badge variant="success" v-if="row.item.is_alive">Enable</b-badge>
        <b-badge v-else variant="secondary">Disable</b-badge>
      </template>
      <template #cell(type)="row">
        {{ row.item.type || '-' }}
      </template>
      <template #cell(name)="row">
        <a href="javascript:void();" @click="(x) => { row.toggleDetails(x) }">{{ row.item.name | truncate(50) }}</a>
      </template>
      <template #cell(code)="row">
        {{ row.item.code | truncate(50) }}
      </template>
      <template #cell(total)="row">
        {{ row.item.total | number }}
      </template>

      <!-- detail -->

      <template #row-details="row">
        <b-card>

          <b-row class="mb-4">
            <b-col sm="2" md="2" lg="2" class="text-sm-right">Status :</b-col>
            <b-col>
              <c-switch color="info" label size="lg" id="ph_is_alive" v-model="row.item.is_alive" />
            </b-col>
            <b-col sm="1" md="1" lg="1"></b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col sm="2" md="2" lg="2" class="text-sm-right">Name :</b-col>
            <b-col>
              <b-input type="text" v-model="row.item.name"></b-input>
            </b-col>
            <b-col sm="1" md="1" lg="1"></b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col sm="2" md="2" lg="2" class="text-sm-right">Type :</b-col>
            <b-col>
              <!-- <b-input type="text" v-model="row.item.type"></b-input> -->
              <v-select label="name" v-model="row.item.type" :options="ob_type"></v-select>
            </b-col>
            <b-col sm="1" md="1" lg="1"></b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col sm="2" md="2" lg="2" class="text-sm-right">Code :</b-col>
            <b-col>
              <b-form-textarea id="textarea" v-model="row.item.code" placeholder="Enter something..." rows="3"
                max-rows="6"></b-form-textarea>
            </b-col>
            <b-col sm="1" md="1" lg="1"></b-col>
          </b-row>

          <b-row class="mb-4">
            <b-col sm="2" md="2" lg="2"></b-col>
            <b-col>
              <b-button block variant="danger" @click="() => { row.item.is_del = true; save(row.item); }">
                Remove
              </b-button>
            </b-col>
            <b-col>
              <b-button block variant="success" @click="save(row.item)">
                Save
              </b-button>
            </b-col>
            <b-col sm="1" md="1" lg="1"></b-col>
          </b-row>

        </b-card>
      </template>
    </b-table>

    <hr>

    <b-row>
      <b-col>
      </b-col>
      <b-col class="mt-1 d-flex justify-content-center">
        <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage"
          prev-text="Prev" next-text="Next" />
      </b-col>
      <b-col>
      </b-col>
    </b-row>
    <!-- modal area -->

    <b-modal title="Create" class="modal-info" v-model="modal_add" @ok="create()" ok-variant="info">

      <b-row class="mb-4">
        <b-col sm="2" md="2" lg="2" class="text-sm-right">Name :</b-col>
        <b-col>
          <b-input type="text" v-model="model.name"></b-input>
        </b-col>
        <b-col sm="1" md="1" lg="1"></b-col>
      </b-row>

      <b-row class="mb-4">
        <b-col sm="2" md="2" lg="2" class="text-sm-right">Type :</b-col>
        <b-col>
          <v-select label="name" v-model="model.type" :options="ob_type"></v-select>
        </b-col>
        <b-col sm="1" md="1" lg="1"></b-col>
      </b-row>

      <b-row class="mb-4">
        <b-col sm="2" md="2" lg="2" class="text-sm-right">Code :</b-col>
        <b-col>
          <b-form-textarea id="textarea" v-model="model.code" placeholder="Enter something..." rows="3"
            max-rows="6"></b-form-textarea>
        </b-col>
        <b-col sm="1" md="1" lg="1"></b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/f1/custom';
import { api } from '@/f1/service';
import 'vue2-datepicker/index.css';
import moment from 'moment-timezone';
import { Switch as cSwitch } from '@coreui/vue';
import _ from 'lodash';

const default_opt = () => ({
  perPage: 25,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt: {
    created_at_ed: moment().add(1, 'd'),
    created_at_sd: moment().add(1, 'd'),
  }, adv: false,
  pageoptions: [
    { text: '10 rows', value: 10 },
    { text: '25 rows', value: 25 },
    { text: '50 rows', value: 50 },
    { text: '100 rows', value: 100 },
    { text: '200 rows', value: 200 }
  ]
});

export default {
  name: 'Crawler',
  components: { DatePicker, vSelect, cSwitch },
  data: () => ({
    ob_type: ['asp', 'jsp', 'perl', 'php', 'python', 'ruby', 'javascript', 'java', 'etc', 'unknown'],
    model: {
      name: '', code: '', type: '', total: 0,
    },
    select: {},
    datepicker,
    so: default_opt(),
    hash_list: [],
    modal_add: false,
    task : 0,
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', thStyle: 'width: 10%', sortable: true, label: 'No' },
        { key: 'is_alive', sortable: true, label: 'Enable' },
        { key: 'type', sortable: true, label: 'Type' },
        { key: 'name', sortable: true, label: 'Name' },
        { key: 'code', sortable: true, label: 'Code' },
        { key: 'total', sortable: true, label: 'Total' },
      ]
    }
  },
  methods: {
    async create() {
      try {

        let rs = await api.dms.regex.add(this.model);

        this.refresh();

        return console.log('rs', rs)

      } catch (e) { this.$toastr.e(e.data || e); }
    },
    async save(item) {
      try {
        let rs = await api.dms.regex.update(item);

        this.refresh();

        return console.log('rs', rs)

      } catch (e) { this.$toastr.e(e.data || e); }
    },
    resetField() { this.so = default_opt(); this.refresh(); this.so.adv = !this.so.adv },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() {
      this.$refs._list.refresh();
    },
    getRowCount() { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      this.summary()
      let so = {
        ok: ctx.sortBy,
        od: ctx.sortDesc ? 'd' : 'a',
        pg: ctx.currentPage || this.so.currentPage || 1,
        pc: ctx.perPage || this.so.perPage || 10,
        sk: this.so.sk || 'name',
        sv: (this.so.sv || '').trim(),
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, and: [{ name: 'is_del', op: '=', value: false }], or: [], sort: [{ name: 'total', op: 'desc' }] }
      // order
      if (so.ok) { search.sort.push({ name: so.ok, op: so.od == 'd' && 'desc' }); }
      // search

      if (so.sk && so.sv) {
        if (!so.ok) {
          search.sort.push({ name: so.sk, op: so.od == 'd' && 'desc' });
        }
        search.or.push({ name: so.sk, value: `%${so.sv.trim()}%`, op: 'like' });
      }

      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        if (value != null && value != "") {
          switch (key) {
            case 'created_at_sd': search.and.push({ name: 'created_at', value: new Date(value), op: '>=' }); break;
            case 'created_at_ed': var d = new Date(value); d.setDate(d.getDate() + 1); search.and.push({ name: 'created_at', value: d, op: '<' }); break;
            default: search.and.push({ name: key, value: `%${value}%`, op: 'like' }); break;
          }
        }
      }

      try {
        let rs = await api.dms.regex.list(search);
        this.so.totalRows = rs.count;

        this.hash_list = _.map(rs.result, x => x.file_hash)

        return rs.result;

      } catch (e) { this.$toastr.e(e.data || e); }
    },
    detail(item) { this.$router.push({ name: 'cti_webshell', params: { id: item.id } }); },
    async summary() {

      try {
        let rs = await api.dms.regex.summary();
        this.task = rs.task ? rs.task : this.task

      } catch (e) { this.$toastr.e(e.data || e); }
    },
  },
  created() { },
  destroyed() { },
  mounted() { },
}
</script>
